export default __webpack_public_path__ + "static/SR France - Safety Data Sheet - Burnt Sugar (Liquid)-8940881a00436b0dc7ec98cad6945aaa.pdf";